// extracted by mini-css-extract-plugin
export default {"shortCutAmountButton":"BuyInAmountBox_shortCutAmountButton__PoVVW","shortCutAmountActiveButton":"BuyInAmountBox_shortCutAmountActiveButton__bHtKd"};